import {
	Card,
	CardBody,
	Input,
	Table,
	TableCell,
	TableContainer,
	TableHeader,
} from '@windmill/react-ui';
import SubscribeTable from 'components/subscribe/SubscribeTable';
import NotFound from 'components/table/NotFound';
import PageTitle from 'components/Typography/PageTitle';
import useAsync from 'hooks/useAsync';
import useFilter from 'hooks/useFilter';
import { useState, useEffect } from 'react';
import DataWrapper from './DataWrapper';
import SubscribeServices from 'services/SubscribeServices';
import sidebar from 'routes/sidebar';
import { FiRefreshCcw } from 'react-icons/fi';
import { useContext } from 'react';
import { SidebarContext } from 'context/SidebarContext';

const Subscribe = () => {
	const adminInfo = localStorage.getItem('adminInfo')
		? JSON.parse(localStorage.getItem('adminInfo'))
		: null;
	const { data, loading, error } = useAsync(SubscribeServices.getAllSubscribe);
	//const subscribe = data?.data || [];
	// const [loading, setLoading] = useState(false);
	const [itemsPerPage, setItemsPerPage] = useState(10);
	const { setIsUpdate } = useContext(SidebarContext);
	const [status, setStatus] = useState('');
	useEffect(() => {
		if (data?.status) {
			setStatus(data.status);
		} else {
			setStatus(false);
		}
	}, [data?.status]);
	// const hideView = adminInfo?.permission?.some(
	//   (perm) => perm.id_tab === "subscribe" && perm.view === 1
	// );
	const isAdmin = adminInfo?.id === 1;

	const hideView = isAdmin
		? true
		: adminInfo?.permission?.some(
				(perm) => perm.id_tab === 'subscribe' && perm.view === 1
		  );

	const [subscribeData, setSubscribeData] = useState([]);
	const {
		subscribeRef,
		dataTable,
		serviceData,
		handleSubmitSubscribe,
		currentPage,
	} = useFilter(subscribeData, itemsPerPage);
	useEffect(() => {
		if (serviceData.length !== 0) {
			setItemsPerPage(serviceData.length);
		}
	}, [serviceData]);
	useEffect(() => {
		if (data) {
			const responseData = data?.data || [];
			if (Array.isArray(responseData)) {
				const updatedData = responseData.map(
					({ id, email, active, ...rest }) => ({
						id,
						email,
						active,
						...rest,
					})
				);
				setSubscribeData(updatedData);
			} else {
				console.error('Expected an array but got:', responseData);
			}
		} else {
			console.error('Data is null or undefined');
		}
	}, [data]);

	const handleRefresh = () => {
		setIsUpdate(true);
	};

	return (
		<>
			{hideView && (
				<>
					<PageTitle sidebar={sidebar().sidebar} />

					<Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
						<CardBody>
							<div
								style={{ width: '600px' }}
								className="flex gap-6 items-center"
							>
								<Input
									ref={subscribeRef}
									className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
									type="search"
									name="search"
									placeholder="Quick Search"
									autoComplete="off"
									onChange={handleSubmitSubscribe}
								/>
								<FiRefreshCcw
									onClick={() => {
										handleRefresh();
									}}
									cursor="pointer"
								/>
							</div>
						</CardBody>
					</Card>

					<DataWrapper loading={loading} error={error} status={status}>
						{serviceData?.length !== 0 ? (
							<TableContainer
								className="mb-4"
								style={{
									maxHeight: '60vh',
									overflowY: 'scroll',
									scrollbarWidth: 'thin',
								}}
							>
								<Table>
									<TableHeader className="custom-table-header capitalize sticky top-0 z-10">
										<tr>
											<TableCell className="text-center">Sl.No.</TableCell>
											<TableCell className="text-center">Email</TableCell>
											<TableCell className="text-center">Active</TableCell>
										</tr>
									</TableHeader>
									<SubscribeTable
										subscribe={dataTable}
										perpage={itemsPerPage}
										currentPage={currentPage}
									/>
								</Table>
								{/* <TableFooter>
            <Pagination
              totalResults={totalResults}
              resultsPerPage={resultsPerPage}
              onChange={handleChangePage}
              label="Table navigation"
            />
          </TableFooter> */}
							</TableContainer>
						) : (
							<NotFound title="There are no Subscribers." />
						)}
					</DataWrapper>
				</>
			)}
		</>
	);
};

export default Subscribe;
